export default "__VITE_ASSET__Cl51Zjr2__"